import { render, staticRenderFns } from "./goods-vip-forever-protocol2024618.vue?vue&type=template&id=a9c6a9b2&scoped=true"
import script from "./goods-vip-forever-protocol2024618.vue?vue&type=script&lang=js"
export * from "./goods-vip-forever-protocol2024618.vue?vue&type=script&lang=js"
import style0 from "./goods-vip-forever-protocol2024618.vue?vue&type=style&index=0&id=a9c6a9b2&prod&lang=scss"
import style1 from "./goods-vip-forever-protocol2024618.vue?vue&type=style&index=1&id=a9c6a9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c6a9b2",
  null
  
)

export default component.exports